'use strict';

import classifyDirective from './directive';

const MODULE_NAME = 'daupler.classify_v1';

var app = angular.module(MODULE_NAME, [
]);

app.directive('dauplerClassifyV1', classifyDirective);

export default MODULE_NAME;
